// import React, { useCallback, useEffect, useState } from "react";
// import { Button, Col, Container, Fade, Form, Row } from "react-bootstrap";



// // css
// import styles from "./addForm.module.scss";
// import { Formik } from "formik";
// import AppInputField from "components/shared/FormComponents/AppInputField";
// import { cloneDeep, debounce } from "lodash";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { successMessageToast, userFullName } from "helpers/common";
// import { MANAGE_SUPPORT_STAFF_LIST } from "config/paths";
// import LoadingIndicator from "components/shared/LoadingIndicator";
// import addStaffSchema from "./addStaff.schema";
// import { SUPPORT_STAFF_CLIENT_TYPE_OPTIONS, GRADE_OPTIONS, CLIENT_TYPE_OPTIONS, STATUS_OPTIONS } from "config/constants";
// import { CommonMultiSelect, CommonSelect, CommonToolTip, CstmPagination, RequiredFieldAstrick } from "components/Common/Common";
// import { useGetSchoolDivisonListForFilterQuery } from "store/services/schoolsDivisons";
// import { useLazyGetAssociatedClientsQuery } from "store/services/utility";
// import { useAssignAssociatedTherapistMutation, useCreateSupportStaffMutation, useDeleteAssociatedCLientMutation, useDeleteAssociatedTherapistMutation, useGetStaffAssociatedTherapistListQuery, useGetSupportStaffDetailQuery, useUpdateSupportStaffMutation } from "store/services/supportStaff";
// import ConfirmationPop from "components/Modals/ConfirmationPop";
// import LoadingOverlay from "components/shared/LoadingOverlay";
// import Select from 'react-select';
// import { useGetDisciplineListQuery } from "store/services/disciplines";
// import { useGetTherapistsListQuery } from "store/services/therapistProfiles";
// import TableLayout from "components/TableLayout";
// import { DeleteIcon } from "Assets/icons";
// import AssignStaffToTherapistPop from "components/Modals/AssignStaffToTherapist";
// import TableHeader from "components/shared/FormComponents/TableHeader";

// const AddSupportStaff = () => {

//   const { id: staffId } = useParams();
//   const editMode = !!staffId;
//   const navigate = useNavigate();

//   const [selectedDiscipline, setSelectedDiscipline] = useState(null);
//   const [newTherapist, setNewTherapist] = useState(null)
//   const [pageSize, setPageSize] = useState(10);
//   const [therapistOptions, setTherapistOptions] = useState([]);
//   const [therapistModal, setTherapistModal] = useState(false)
//   const [showModal, setShowModal] = useState(false)
//   const [modalType, setModalType] = useState(null)
//   const [currentTherapist, setCurrentTherapist] = useState(null)
//   const [therapistFilter, setTherapistFilter] = useState({ search: "", status: "", page: 1, limit: pageSize })
//   const [initialValues, setInitialValues] = useState({
//     // discipline_id: "",
//     firstname: "",
//     lastname: "",
//     phone: "",
//     email: "",
//     city_town: "",
//     status: "active",
//     client_type: "",
//     isLoginAllowed: "active",
//     // division: "",
//     // school: "",
//     // grade: "",
//     description: "",
//   });

//   const { data: schoolDivisonsList } = useGetSchoolDivisonListForFilterQuery();
//   const schoolDivisionOptions = schoolDivisonsList?.map(item => ({ value: item.id, label: item.title }))
//   const { data: disciplineList, isLoading: disciplineListLoading } = useGetDisciplineListQuery({});
//   const disciplineListOptions = disciplineList?.records?.map(x => ({ label: x.name, value: x.id, discipline_areas: x.discipline_areas }))
//   const { data: therapistListData, isFetching: therapistsLoading } = useGetTherapistsListQuery({ discipline: selectedDiscipline, type: "veteran", status: "active" }, { skip: !selectedDiscipline });
//   const therapistList = therapistListData?.records;
//   const [deleteTherapist, { isLoading: deleteTherapistLoading }] = useDeleteAssociatedTherapistMutation()
//   const [assignToTherapist, { isLoading: assigntToTherapistLoading }] = useAssignAssociatedTherapistMutation()
//   const { data: therapistsList, isLoading: therapistsListLoading, isFetching: therapistsListFetching, isError: therapistListError } = useGetStaffAssociatedTherapistListQuery({ id: staffId, ...therapistFilter })
//   const therapistsTotalRecord = therapistsList?.associatedTherapist?.totalTherapistRecords || 0;
//   const therapistsTotalPages = Math.ceil(therapistsTotalRecord / pageSize);

//   const [updateStaff, { isLoading: updateStaffLoading }] = useUpdateSupportStaffMutation();
//   const [createStaff, { isLoading: createStaffLoading }] = useCreateSupportStaffMutation();
//   const { data, isFetching, isLoading } = useGetSupportStaffDetailQuery(staffId, { skip: !staffId });
//   const staffDetails = data?.record;


//   const therapistColumn = [
//     {
//       head: "Name",
//       accessor: "label",
//       isComponent: true,
//       // sorter: true,
//       component: (item, ind) => (
//         <h6 className="m-0 fw-bold themeBlue">{userFullName(item?.associatedTherapists)}</h6>
//       ),
//     },
//     {
//       head: "Action",
//       accessor: "",
//       isComponent: true,
//       component: (item) => (
//         <div className="ActnBtn d-flex align-items-center  gap-10">

//           <CommonToolTip
//             text={"Delete"}
//             component={<Button
//               className="p-0"
//               disabled={deleteTherapistLoading}
//               variant="transparent"
//               type="button"
//               onClick={() => {
//                 setCurrentTherapist(item);
//                 setModalType("delete");
//                 setShowModal(true);
//               }}
//             >
//               <DeleteIcon />
//             </Button>}
//           />
//         </div>
//       ),
//     },
//   ]

//   const handleSubmit = async (payload) => {

//     try {

//       let values = cloneDeep(payload);
//       values.client_type = payload?.client_type?.value;
//       // values.division = payload?.division?.value;
//       // values.school = Array.isArray(payload?.school)
//       //   ? payload?.school.map(school => school.value)
//       //   : [payload?.school?.value];
//       // values.grade = payload?.grade.value || '';
//       values.discipline_id = payload?.discipline_id?.value
//       values.associated_therapists = payload?.associated_therapists?.map((item) => item.value)
//       const result = editMode ? await updateStaff({ data: values, staffId }) : await createStaff(values);
//       if (result?.error) {

//         console.error("Error create teacher", result.error);
//         return;
//       };

//       successMessageToast(result?.data?.message);
//       navigate(MANAGE_SUPPORT_STAFF_LIST);

//     } catch (err) { console.error("Error create teacher", err); }
//   };

//   const handleAssignToTherapist = async (values) => {
//     const body = {
//       staff_id: staffId,
//       therapist_id: values?.therapist_id?.value
//     }
//     try {
//       await assignToTherapist(body).unwrap()
//       setTherapistModal(false)
//     } catch (error) {
//       console.log('Error ASsigning to therapist', error)
//     }
//   }

//   const handleDeleteAssociatedTherapist = async () => {
//     setShowModal(false)
//     try {
//       const result = await deleteTherapist({ id: currentTherapist?.id }).unwrap()
//       successMessageToast(result.message)
//     } catch (error) {
//       console.log("Error deleting therapist: ", error)
//     }
//   }

//   const handleTherapistsPageChange = (page) => {
//     window.scrollTo(0, 0);
//     setTherapistFilter((prev) => ({ ...prev, page }));
//   };

//   const handleTherapistFilterChange = (key) => (value) => {
//     setTherapistFilter((prev) => ({ ...prev, [key]: value, page: 1 }))
//   }

//   const resetTherapistFilter = () => {
//     setTherapistFilter((prev) => ({ ...prev, search: "", status: "", page: 1, limit: pageSize }));
//   };

//   useEffect(() => {
//     setTherapistOptions(therapistList?.length > 0
//       ? therapistList?.map(therapist => ({
//         value: therapist.id,
//         label: userFullName(therapist),
//         email: therapist.email,
//         icon: therapist.therapist_detail?.profile_picture,
//       }))
//       : [])
//   }, [therapistList]);

//   useEffect(() => {

//     if (!staffId) return;

//     if (staffDetails) {


//       // let selectedDivision = schoolDivisionOptions?.find(x => x.value === staffDetails?.staffDetail?.division) || "";

//       // let divisionSchools = schoolDivisonsList?.find(x => x.id === staffDetails?.staffDetail?.division) || "";
//       // let selectedSchool = [];

//       // if (divisionSchools && Array.isArray(divisionSchools.schools)) {
//       //   selectedSchool = divisionSchools?.schools
//       //     .filter(school => staffDetails?.staffDetail?.school.includes(school.id))
//       //     .map(school => ({
//       //       value: school.id,
//       //       label: school.name
//       //     }));
//       // }

//       setInitialValues({
//         ...initialValues,
//         firstname: staffDetails?.firstname || "",
//         lastname: staffDetails?.lastname || "",
//         phone: staffDetails?.phone || "",
//         email: staffDetails?.email || "",
//         city_town: staffDetails?.staffDetail?.city_town || "",
//         status: staffDetails?.status || "",
//         // client_type: CLIENT_TYPE_OPTIONS?.find(x => x.value === staffDetails?.staffDetail?.client_type) || "",
//         client_type: SUPPORT_STAFF_CLIENT_TYPE_OPTIONS?.find(x => x.value === staffDetails?.staffDetail?.client_type) || "",
//         // division: schoolDivisionOptions?.find(x => x.value === staffDetails?.staffDetail?.division) || "",
//         // division: selectedDivision || "",
//         // school: selectedSchool || "",
//         // grade: GRADE_OPTIONS?.find(x => x.value === staffDetails?.staffDetail?.grade) || "",
//         isLoginAllowed: staffDetails?.isLoginAllowed || "",
//         description: staffDetails?.staffDetail?.description || "",
//         associated_therapists: therapistsList?.associatedTherapist?.therapists?.map((item) => ({ label: userFullName(item?.associatedTherapists), value: item?.associatedTherapists?.id })),
//         discipline_id: { label: staffDetails?.staffDetail?.staff_discipline_Assigned?.name, value: staffDetails?.staffDetail?.staff_discipline_Assigned?.id }
//       });
//     };

//   }, [staffDetails, therapistsList]);

//   return (
//     <>
//       <ConfirmationPop
//         confirmation={showModal}
//         setConfirmation={setShowModal}
//         confirmHandler={handleDeleteAssociatedTherapist}
//         type={modalType}
//       />
//       <AssignStaffToTherapistPop showPopup={therapistModal} setShowPopup={setTherapistModal} handleSubmit={handleAssignToTherapist} setTherapist={setNewTherapist} isLoading={assigntToTherapistLoading} discipline={{ label: staffDetails?.staffDetail?.staff_discipline_Assigned?.name, value: staffDetails?.staffDetail?.staff_discipline_Assigned?.id }} />
//       <section className={`${styles.addForm} position-relative py-4 addForm`}>
//         <Container fluid={true}>
//           <Row>
//             <Col lg="12" className="my-2">
//               <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
//                 <div className="left">
//                   <div className="pageHead pb-3 d-flex align-items-center">
//                     <Link
//                       className="themeBlue fw-sbold back-to-btn"
//                       to={MANAGE_SUPPORT_STAFF_LIST}
//                     >
//                       <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         <path d="M6 12L0 6L6 0L7.425 1.4L2.825 6L7.425 10.6L6 12ZM18 14V10C18 9.16667 17.7083 8.45833 17.125 7.875C16.5417 7.29167 15.8333 7 15 7H8.825L12.425 10.6L11 12L5 6L11 0L12.425 1.4L8.825 5H15C16.3833 5 17.5625 5.4875 18.5375 6.4625C19.5125 7.4375 20 8.61667 20 10V14H18Z" fill="#1C1B1F" />
//                       </svg> Back
//                     </Link>
//                     <h6 className="m-0 fw-bold themeBlue">{editMode ? "Edit Support Staff" : "Add New Support Staff"}</h6>
//                   </div>
//                 </div>
//               </div>
//             </Col>
//             {
//               isLoading ? <LoadingIndicator /> : isFetching ? <LoadingOverlay /> :
//                 <Col lg="12" className="my-2">

//                   <Formik
//                     initialValues={initialValues}
//                     validationSchema={addStaffSchema}
//                     onSubmit={handleSubmit}
//                     enableReinitialize
//                   >
//                     {({
//                       handleSubmit,
//                       setFieldValue,
//                       values,
//                       errors,
//                       touched
//                     }) => (
//                       <Form onSubmit={handleSubmit}>
//                         <div
//                           className="py-3"
//                           style={{ borderTop: "1px solid #41a2a84d" }}
//                         >
//                           <Row>
//                             <Col md="4" sm="6" className="my-2">
//                               <label
//                                 htmlFor=""
//                                 className="form-label themeBlue fw-bold mb-0 d-flex"
//                               >
//                                 Last Name
//                                 <RequiredFieldAstrick />
//                               </label>
//                               {console.log('errors of formik', errors, values)
//                               }                              <AppInputField
//                                 type="text"
//                                 name="lastname"
//                                 placeholder="e.g Smith"
//                                 className={`${styles.formControl} form-control`}
//                                 maxLength={30}
//                               />
//                             </Col>
//                             <Col md="4" sm="6" className="my-2">
//                               <label
//                                 htmlFor=""
//                                 className="form-label themeBlue fw-bold mb-0 d-flex"
//                               >
//                                 First Name
//                                 <RequiredFieldAstrick />
//                               </label>
//                               <AppInputField
//                                 type="text"
//                                 name="firstname"
//                                 placeholder="e.g John"
//                                 className={`${styles.formControl} form-control`}
//                                 maxLength={30}
//                               />
//                             </Col>
//                             <Col md="4" sm="6" className="my-2">
//                               <label
//                                 htmlFor=""
//                                 className="form-label themeBlue fw-bold mb-0 d-flex"
//                               >
//                                 Email
//                                 <RequiredFieldAstrick />
//                               </label>
//                               <AppInputField
//                                 type="text"
//                                 name="email"
//                                 placeholder="e.g abc@example.com"
//                                 className={`${styles.formControl} form-control`}
//                               />
//                             </Col>
//                             <Col md="4" sm="6" className="my-2">
//                               <label
//                                 htmlFor=""
//                                 className="form-label themeBlue fw-bold mb-0 d-flex"
//                               >
//                                 Phone
//                                 <RequiredFieldAstrick />
//                               </label>
//                               <AppInputField
//                                 type="text"
//                                 name="phone"
//                                 placeholder="e.g +1 23234545"
//                                 className={`${styles.formControl} form-control`}
//                                 maxLength={25}
//                               />
//                             </Col>
//                             <Col md="4" sm="6" className="my-2">
//                               <label
//                                 htmlFor=""
//                                 className="form-label themeBlue fw-bold mb-0 d-flex"
//                               >
//                                 Client Category
//                                 <RequiredFieldAstrick />
//                               </label>
//                               <CommonSelect
//                                 name="client_type"
//                                 // option={CLIENT_TYPE_OPTIONS}
//                                 option={SUPPORT_STAFF_CLIENT_TYPE_OPTIONS}
//                               />
//                             </Col>
//                             {/* {values?.client_type?.value == "school" &&
//                               <>
//                                 <Col md="4" sm="6" className="my-2">
//                                   <label
//                                     htmlFor=""
//                                     className="form-label themeBlue fw-bold mb-0 d-flex"
//                                   >
//                                     School Division
//                                     <RequiredFieldAstrick />
//                                   </label>
//                                   <CommonSelect
//                                     name="division"
//                                     option={schoolDivisionOptions}
//                                     onChange={() => setFieldValue("school", null)}
//                                   />
//                                 </Col>
//                                 <Col md="4" sm="6" className="my-2">
//                                   <label
//                                     htmlFor=""
//                                     className="form-label themeBlue fw-bold mb-0 d-flex"
//                                   >
//                                     School
//                                     <RequiredFieldAstrick />
//                                   </label>
//                                   <CommonMultiSelect
//                                     name="school"
//                                     placeholder={"Please Select School"}
//                                     option={function () {
//                                       let schoolsList =
//                                         values.division?.value &&
//                                         schoolDivisonsList?.length > 0 &&
//                                         schoolDivisonsList.find(division => division.id === values.division?.value)?.schools;
//                                       if (!schoolsList?.length) {
//                                         return;
//                                       }
//                                       return cloneDeep(schoolsList || [])?.sort((a, b) => a?.name?.localeCompare(b?.name))?.map(item => ({
//                                         value: item.id,
//                                         label: item.name,
//                                       }))
//                                     }()}
//                                   />
//                                 </Col>
//                                 <Col md="4" sm="6" className="my-2">
//                                   <label
//                                     htmlFor=""
//                                     className="form-label themeBlue fw-bold mb-0 d-flex"
//                                   >
//                                     Grade
//                                   </label>
//                                   <CommonSelect
//                                     name="grade"
//                                     option={GRADE_OPTIONS}
//                                   />
//                                 </Col>
//                               </>} */}

//                             <Col md="4" sm="6" className="my-2">
//                               <label
//                                 htmlFor=""
//                                 className="form-label themeBlue fw-bold mb-0 d-flex"
//                               >
//                                 City/Town
//                                 <RequiredFieldAstrick />
//                               </label>
//                               <AppInputField
//                                 name="city_town"
//                                 placeholder="City/Town"
//                                 className={`${styles.formControl} form-control`}
//                                 maxLength={30}
//                               />
//                             </Col>

//                             {
//                               !editMode &&
//                               <>

//                                 <Col md="4" sm="6" className="my-2">
//                                   <label
//                                     htmlFor=""
//                                     className="form-label themeBlue fw-bold mb-0 d-flex"
//                                   >
//                                     Select Discipline
//                                     <RequiredFieldAstrick />
//                                   </label>
//                                   <CommonSelect
//                                     isDisabled={editMode}
//                                     name="discipline_id"
//                                     placeholder="Select Discipline"
//                                     classNamePrefix={"khan"}
//                                     option={disciplineListOptions}
//                                     onChange={(selected) => {
//                                       setSelectedDiscipline(selected?.value);
//                                       // setFieldValue("associated_therapists", null);
//                                       setTherapistOptions([])
//                                     }}
//                                     isLoading={disciplineListLoading}
//                                   />
//                                 </Col>
//                                 <Col md="4" sm="6" className="my-2">
//                                   <h6 className="m-0 fw-sbold themeBlue pb-2 d-flex">
//                                     Assign to Therapist
//                                     <RequiredFieldAstrick />
//                                   </h6>
//                                   <CommonMultiSelect
//                                     clearable={false}
//                                     name="associated_therapists"
//                                     placeholder="Select Therapist"
//                                     option={therapistOptions}
//                                     isLoading={therapistsLoading}
//                                   // onChange={(selected) => setFieldValue("therapist_id", selected?.value)}
//                                   />
//                                 </Col>
//                               </>
//                             }
//                             {
//                               editMode &&
//                               <>
//                                 <Col lg="12" className="my-3">
//                                   <div className="py-2">
//                                     <div className="row">
//                                       <div className="my-2 col-lg-12">
//                                         {/* <h6 className="m-0 themeBlue fw-bold pb-2">Designation (Yet to be implemented)Associated Therapists</h6> */}
//                                         <div className="TableFilter d-flex align-items-center justify-content-between">
//                                           <div className="left" >
//                                             <TableHeader
//                                               hideStatusFilter
//                                               heading={"Associated Therapist Profiles"}
//                                               handleFilterChange={handleTherapistFilterChange}
//                                               resetFilter={resetTherapistFilter}
//                                               filter={therapistFilter}
//                                               searchPlaceholder="First, Last Name"
//                                             />
//                                           </div>
//                                           <div className="right">
//                                             <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
//                                               <li className="">
//                                                 <Button
//                                                   type="button"
//                                                   className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold"
//                                                   onClick={() => setTherapistModal(true)}
//                                                 >
//                                                   Assign To
//                                                 </Button>
//                                               </li>
//                                             </ul>
//                                           </div>
//                                         </div>
//                                         <div className="table-outer">
//                                           {therapistsListLoading ? (
//                                             <div style={{ height: "200px" }}>
//                                               <LoadingIndicator />
//                                             </div>
//                                           ) : therapistListError ? (
//                                             <ErrorComponent />
//                                           ) : (
//                                             <>
//                                               {(therapistsListFetching) && (
//                                                 <LoadingOverlay />
//                                               )}
//                                               <TableLayout
//                                                 data={therapistsList?.associatedTherapist?.therapists}
//                                                 column={therapistColumn}
//                                               // url={"/manage-support-staff/details"}
//                                               // filter={filter}
//                                               // handleSort={handleFilterChange("sort")}
//                                               />
//                                             </>
//                                           )}
//                                           <CstmPagination
//                                             totalPages={therapistsTotalPages}
//                                             activePage={therapistFilter?.page}
//                                             handlePageChange={handleTherapistsPageChange}
//                                           />
//                                           {touched.associated_therapists && errors.associated_therapists ? (
//                                             <div className="error">{errors.associated_therapists}</div>
//                                           ) : null}
//                                         </div>
//                                       </div>
//                                     </div>
//                                   </div>
//                                 </Col>
//                               </>
//                             }
//                           </Row>
//                         </div>
//                         <div
//                           className="py-3"
//                           style={{ borderTop: "1px solid #41a2a84d" }}
//                         >
//                           <Row className="mt-1 ">
//                             <Col md="8" sm="6" className="my-2">
//                               <label
//                                 htmlFor=""
//                                 className="form-label themeBlue fw-bold mb-0"
//                               >
//                                 Description
//                               </label>
//                               <AppInputField
//                                 name="description"
//                                 fieldType="textarea"
//                                 rows={10}
//                                 type="text"
//                                 placeholder=""
//                                 className={`${styles.formControl} form-control`}
//                                 maxLength={500}
//                               />
//                             </Col>
//                           </Row>
//                         </div>
//                         <Row className="mt-4">
//                           <Col className="my-2" lg="12">
//                             <div
//                               className={`${styles.btnWrpper} btnWrpper d-flex align-items-center gap-10 pt-3`}
//                               style={{ borderTop: "1px solid #41a2a84d" }}
//                             >
//                               <Button disabled={createStaffLoading || updateStaffLoading} type="submit" className="d-flex align-items-center justify-content-center commonBtn">
//                                 {createStaffLoading || updateStaffLoading ? <LoadingIndicator inline /> : "Save"}

//                               </Button>
//                               <Button
//                                 type="button"
//                                 className="d-flex align-items-center justify-content-center commonBtn borderedBtn bg-transparent"
//                                 onClick={() => navigate(MANAGE_SUPPORT_STAFF_LIST)}
//                               >
//                                 Cancel
//                               </Button>
//                             </div>
//                           </Col>
//                         </Row>
//                       </Form>
//                     )}
//                   </Formik>
//                 </Col>
//             }
//           </Row>
//         </Container>
//       </section>
//     </>
//   );
// };

// export default AddSupportStaff;
import AddSchoolStaffV2 from "./AddSchoolStaffV2";

import React from 'react'

function index() {
  return (
    <div>
      <AddSchoolStaffV2 />

    </div>
  )
}

export default index

